import { render, staticRenderFns } from "./AddInstrument.vue?vue&type=template&id=764f977f"
import script from "./AddInstrument.vue?vue&type=script&lang=js"
export * from "./AddInstrument.vue?vue&type=script&lang=js"
import style0 from "./AddInstrument.vue?vue&type=style&index=0&id=764f977f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports